<template>
  <div>
    <!-- Modal -->
    <div
        class="modal show fade modal-secondary text-left"
        style="display: block;"
        v-if="show"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- Header -->
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Payment Methods
            </h4>
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="handleClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="card">
              <div
                  class="card-body table-responsive p-0 table-striped table-hover table-bordered"
              >
                <table
                    class="table table-head-fixed table-hover-animation text-nowrap"
                >
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Status</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="(paymentMethod, index) in paymentMethods" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ paymentMethod.name }}</td>
                    <td>{{ paymentMethod.code }}</td>
                    <td>
                      <span v-if="paymentMethod.pivot.status === 0" class="badge badge-light-warning badge-glow badge-sm">
                        Generated for all Excluding this
                      </span>
                      <span v-else-if="paymentMethod.pivot.status === 1" class="badge badge-light-success badge-glow badge-sm">
                        Generated only for this
                      </span>
                      <span v-else class="badge badge-light-dark badge-glow badge-sm">
                        -
                      </span>
                    </td>
                  </tr>

                  <tr v-if="paymentMethods.length === 0">
                    <td colspan="4" class="text-center">
                      No payment methods available
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer justify-content-between">
            <button
                type="button"
                class="btn btn-danger"
                @click="handleClose"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Backdrop -->
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data'],
  data() {
    return {
      paymentMethods: []
    }
  },
  watch: {
    show(val) {
      this.paymentMethods = []

      if (val) {
        this.paymentMethods = this.data || []
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('hide')
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
